import { UserPermissionDto } from '@/api/generated';

import { RouteEnum } from './Route.model';

export const ROUTES_PERMISSIONS: Record<RouteEnum, (string[] | string)[]> = {
  [RouteEnum.ADMIN]: [[UserPermissionDto.AdminPanelAccess]],
  [RouteEnum.ADMIN_CERTIFICATION]: [UserPermissionDto.AdminPanelAccess],
  [RouteEnum.ADMIN_CERTIFICATION_DETAIL]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_EXAM_STAGE]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_EXAM_STAGE_CONFIG]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_EXAM_STAGE_DAY]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_EXAM_STAGE_DAYS]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_EXAM_STAGE_EXAM]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_EXAM_STAGE_PARTICIPANTS]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_LIST]: [
    UserPermissionDto.AdminPanelAccess,
    [
      UserPermissionDto.CertificationManagementRead,
      UserPermissionDto.CertificationExamDayManagement,
    ],
  ],
  [RouteEnum.ADMIN_CERTIFICATION_PARTICIPANTS]: [
    UserPermissionDto.AdminPanelAccess,
    UserPermissionDto.CertificationManagementRead,
  ],
  [RouteEnum.ADMIN_CERTIFICATION_SURVEY_DETAIL]: [
    UserPermissionDto.AdminPanelAccess,
    UserPermissionDto.CertificationManagementRead,
  ],
  [RouteEnum.ADMIN_CERTIFICATION_TEST_STAGE]: [
    UserPermissionDto.AdminPanelAccess,
    UserPermissionDto.CertificationManagementRead,
  ],
  [RouteEnum.ADMIN_CERTIFICATION_TEST_STAGE_TERM]: [
    UserPermissionDto.AdminPanelAccess,
    UserPermissionDto.CertificationManagementRead,
  ],
  [RouteEnum.ADMIN_ROOT]: [[UserPermissionDto.AdminPanelAccess]],
  [RouteEnum.AREA]: [UserPermissionDto.SuccessionTabAccess],
  [RouteEnum.CERTIFICATION]: [],
  [RouteEnum.CONTACT]: [],
  [RouteEnum.EMPLOYEE_PROFILE_NEW]: [],
  [RouteEnum.EMPLOYEE_PROFILES_SEARCH]: [UserPermissionDto.EmployeesTabAccess],
  [RouteEnum.EXAMINEE_EXAM]: [UserPermissionDto.CertificationExecution],
  [RouteEnum.FORBIDDEN]: [],
  [RouteEnum.LOGIN_SUCCESSFUL]: [],
  [RouteEnum.MY_PROFILE]: [UserPermissionDto.EmployeesSelfProfile],
  [RouteEnum.MY_PROFILE_DASHBOARD]: [UserPermissionDto.EmployeesSelfProfile],
  [RouteEnum.NESTED_STRUCTURE]: [UserPermissionDto.StructureTabAccess],
  [RouteEnum.NEWS]: [UserPermissionDto.NewsRead],
  [RouteEnum.NOT_AUTHORIZED]: [],
  [RouteEnum.NOT_FOUND]: [],
  [RouteEnum.NOTIFICATIONS]: [],
  [RouteEnum.ORGANIZATION_CHART]: [UserPermissionDto.StructureTabAccess],
  [RouteEnum.ROOT]: [],
  [RouteEnum.SUCCESSION]: [UserPermissionDto.SuccessionTabAccess],
  [RouteEnum.SUCCESSION_CHANGELOG]: [UserPermissionDto.SuccessionTabAccess],
  [RouteEnum.SURVEY_FILL]: [UserPermissionDto.CertificationExecution],
  [RouteEnum.SURVEY_SUMMARY]: [UserPermissionDto.CertificationExecution],
  [RouteEnum.TEAM]: [],
  [RouteEnum.TEST_FILL]: [UserPermissionDto.CertificationExecution],
  [RouteEnum.TEST_RESULT]: [UserPermissionDto.CertificationExecution],
  [RouteEnum.TEST_TERM_UNAVAILABLE]: [UserPermissionDto.CertificationExecution],
};
